// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2Qkq2","box":"WorkspacesBox_box__14Mh8","node":"WorkspacesBox_node__F4OQz"};